export class DonationWay {
    title:string= ''
    titleAr:string= ''
    description:string= ''
    descriptionAr:string= ''
    amount:string= ''
    order:string= ''
    image:string= ''

}
export class UpdateDonationWay {
    id:number
    title:string= ''
    titleAr:string= ''
    description:string= ''
    descriptionAr:string= ''
    amount:string= ''
    order:string= ''
    image:string= ''




}